import type { SearchMetricData } from "../types";

export const initialSearchMetricData: SearchMetricData = {
    all: {},
    organic: {},
    paid: {},
    ppcSpend: {},
    branded: {},
    rankPosition: {},
};

interface SearchMetricAction {
    payload: Partial<SearchMetricData>;
}

export const searchCarouselReducer = (state: SearchMetricData, action: SearchMetricAction): SearchMetricData => {
    if (!action.payload || typeof action.payload !== "object") {return state;}

    const newState = { ...state };

    Object.entries(action.payload).forEach(([metricName, domains]) => {
        if (domains == null) {
            newState[metricName] = {};
            return;
        }

        if (typeof domains !== "object") {return;}

        newState[metricName] = newState[metricName] || {};

        Object.entries(domains).forEach(([domain, value]) => {
            if (typeof value !== "object") {return;}

            newState[metricName][domain] = {
                ...newState[metricName][domain],
                ...value,
            };
        });
    });

    return newState;
};
